import React from "react";
import {
  Box,
  Typography,
  Divider,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Chip,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { bannerPageProps } from "./bannerDetails";
import CloseIcon from "@mui/icons-material/Close";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import moment from "moment";

const BannerDetailsPage: React.FC<bannerPageProps> = ({
  bannerObj,
  handleClose,
}) => {
  if (!bannerObj) {
    return (
      <Box
        sx={{
          width: "100%",
          maxWidth: "1500px",
          margin: "auto",
          mt: "10%",
          p: 3,
          textAlign: "center",
          borderRadius: 2,
          boxShadow: 3,
          bgcolor: "background.paper",
        }}
      >
        <Typography variant="h5" color="primary" fontWeight="bold" mb={2}>
          Banner Details
        </Typography>
        <Typography variant="body1" color="textSecondary">
          No Banner data available.
        </Typography>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="primary"
          sx={{ mt: 3 }}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  const {
    _id,
    title,
    imageUrl,
    redirectUrl,
    description,
    status,
    type,
    section,
    verifyBy,
    startDate,
    endDate,
  } = bannerObj;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1200px",
        margin: "auto",
        mt: 5,
        p: 3,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
      }}
    >
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" color="primary" fontWeight="bold">
          Banner Detail
        </Typography>
        <IconButton onClick={handleClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Box>

      <Grid container spacing={3}>
        {/* Left Section */}
        <Grid item xs={12} md={6} textAlign="left">
          <CardContent>
            <Typography variant="h6" fontWeight="bold" >
              <strong style={{ color: "#000" }}> Title : </strong> {title}
              <span>
                {status === "ACTIVE" ? (
                  <Tooltip title="Active">
                    <IconButton aria-label="status" style={{ color: "#039487" }}>
                      <TaskAltIcon />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title="InActive">
                    <IconButton aria-label="status" style={{ color: "#ff9966" }}>
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </span>
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
              <strong style={{ color: "#000" }}> Redirect Url : </strong>
              <a
                href={redirectUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "none", fontWeight: "normal" }}
              > {redirectUrl || "N/A"}
              </a>
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
              <strong style={{ color: "#000" }}>Type : </strong> {type}
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
              <strong style={{ color: "#000" }}>Section : </strong>{section}
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
              <strong style={{ color: "#000" }}>Start Date : </strong>{moment(startDate).format("D, MMM YYYY") || "No Start Date"}
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
              <strong style={{ color: "#000" }}>End Date : </strong>{moment(endDate).format("D, MMM YYYY") || "No End Date"}
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
              <strong style={{ color: "#000" }}>Verify By : </strong>{verifyBy}
            </Typography>
          </CardContent>
        </Grid>

        <Grid item xs={12} sm={6}>
          {typeof imageUrl === "string" && /\.(mp4|webm|ogg)$/i.test(imageUrl) ? (
            <video
              style={{ width: "100%", borderRadius: 8, cursor: "pointer" }}
              controls
              controlsList="nodownload"
            >
              <source src={imageUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <CardMedia
              component="img"
              image={
                typeof imageUrl === "string"
                  ? imageUrl
                  : imageUrl instanceof File
                    ? URL.createObjectURL(imageUrl)
                    : "https://via.placeholder.com/500x300"
              }
              alt="Banner Image"
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: 2,
              }}
            />
          )}
        </Grid>

      </Grid >

      <Divider sx={{ my: 3 }} />

      <Box display="flex" justifyContent="flex-end">
        <Button onClick={handleClose} variant="contained" color="primary">
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default BannerDetailsPage;